import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import AnnouncementOverviewCard from './AnnouncementOverviewCard';

const AnnouncementOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:announcements.meta.title')} />
      <AnnouncementOverviewCard />
    </ContentLayout>
  );
};

export default AnnouncementOverviewPage;
